<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-06 15:35:08
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 15:35:09
-->
<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-05 21:42:33
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 01:07:15
-->
<template>
  <div class="table">
    <a-tabs>
      <a-tab-pane key="1" tab="订单管理">
        <a-table
          :data-source="data"
          :columns="columns"
          :scroll="{ x: true }"
          rowKey="id"
          style="width: 100%"
        >
          <span slot="status" slot-scope="text">{{ fmtStatus(text) }}</span>
           <template slot="operation" slot-scope="text, record">
           <a
              v-if="record.isCao == 1"
              @click="() => getOrderPdf(record.id)"
              style="margin-right: 8px"
              >导出订单</a
            >
             <a
              v-if="record.isCao == 2"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleEdit(record)"
              >修改状态</a
            >
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model v-model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }">
        <a-form-model-item label="状态">
          <a-select v-if="isEdit" v-model="form.status" :disabled="!isEdit">
            <a-select-option
              v-for="item in [
                { key: 0, value: '交易取消' },
                 { key: 1, value: '交易中' },
                { key: 2, value: '交易完成' },
              ]"
              :key="item.key"
              :value="item.key"
            >
              {{ item.value }}
            </a-select-option>
          </a-select>
          <span v-else>{{ form.trademarkClassify }}</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  // {
  //   title: "订单ID",
  //   dataIndex: "id",
  //   key: "id",
  // },
  // {
  //   title: "商品id",
  //   dataIndex: "productId",
  //   key: "productId",
  // },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
    width: 120,
    ellipsis: true,
  },
  {
    title: "订单号",
    dataIndex: "orderNo",
    key: "orderNo",
    width: 120,
    ellipsis: true,
  },
  {
    title: "客户姓名",
    dataIndex: "userName",
    key: "userName",
    width: 120,
    ellipsis: true,
  },
  {
    title: "客户手机号码",
    dataIndex: "phone",
    key: "phone",
    width: 120,
    ellipsis: true,
  },
  {
    title: "交易金额",
    dataIndex: "money",
    key: "money",
    width: 100,
    ellipsis: true,
  },
  {
    title: "订单类型",
    dataIndex: "type",
    key: "type",
    width: 80,
    ellipsis: true,
  },
  {
    title: "订单状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    width: 120,
    ellipsis: true,
  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "id",
    scopedSlots: { customRender: "operation" },
    width: 120,
    fixed: "right",
    ellipsis: true,
  },
];
import request from "../util/request";
export default {
  name: "user-center-brand",
  data() {
    return {
      data: [],
      columns,
      type: [],
      org: [],
      page: {
        page: 1,
        pageSize: 999,
      },
      title: "",
      visible: false,
      confirmLoading: false,
      isEdit: false,
      parents: [],
      form: {},
      userInfo: {},
      fileUrl:{}
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }

    this.queryList();
    this.queryDict();
    this.queryOrg();
  },
  methods: {
    fmtStatus(text) {
      if (text == 0) {
        return "交易取消";
      } else if (text == 1) {
        return "交易中";
      } else if (text == 2) {
        return "交易完成";
      }
    },
    getOrderPdf(id){
      console.log(id);
      request({
        url: `/api/center/order/getPrintPdf?id=`+id,
      }).then((res) => {
        console.log(res);
        let url = res.data.fileName;
        console.log(url);
        const a = document.createElement('a')
        a.href = url
        a.download = url // 下载后文件名
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click() // 点击下载
        document.body.removeChild(a) // 下载完成移除元素
      });
    },
    handleDetail(record) {
      request({
        url: `/api/center/order/trademarkregister/${record.id}`,
      }).then((res) => {
        this.visible = true;
        this.title = "详情";
        this.isEdit = false;
        this.form = res.data;
      });
    },
    handleEdit(record) {
      this.visible = true;
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(record));
      this.isEdit = true;
    },
    handleOk() {
      const params = Object.assign({}, this.form);
      if (this.isEdit) {
        request({
          url: "/api/center/order/status",
          method:  "post",
          params,
        }).then((res) => {
          if (res.code == "200") {
            this.$message.info("操作成功");
            this.visible = false;
            this.form = {};
            this.queryList();
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.visible = false;
        this.form = {};
      }
    },
    fmttype(text) {
      const result = this.type.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    fmtAgency(text) {
      const result = this.org.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    queryDict() {
      request({
        url: "/api/tool/select/dict/list",
        params: {
          key: "trademarkclassify",
        },
      }).then((res) => {
        console.log("dict", res);
        this.type = res.data;
      });
    },

    queryOrg() {
      request({
        url: "/api/client/common/select/enterprise/list?key=ORG_OWNER",
      }).then((res) => {
        this.org = res.data;
      });
    },
    queryList() {
      request({
        url: "/api/center/order/list",
        params: this.page,
      }).then((res) => {
        console.log("list", res.data);
        if (res.code == "200") {
          this.data = res.data.records;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = false;
    },
  },
};
</script>

<style lang="less"></style>
